import React, { useEffect } from 'react';
import { isObjectEmpty } from 'common/utils/helpers';
import { defaultSWDeviceTypes } from 'common/utils/constants';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import classnames from 'classnames';
import './SoftwareVersionList.css';

export const SoftwareVersionList = (props) => {
  const { softwareVersions, selectedSWVersionID, selectedDeviceTypes, parent } = props;

  let unavailableSwList = [];
  let availableSwList = [];
  let currentSelectedDeviceTypes = [];

  if (selectedDeviceTypes) {
    Object.keys(selectedDeviceTypes).forEach((deviceType) => {
      if (
        Object.keys(selectedDeviceTypes[deviceType].deviceIds).some(
          (deviceId) => selectedDeviceTypes[deviceType].deviceIds[deviceId] === true
        ) &&
        !currentSelectedDeviceTypes.includes(deviceType)
      ) {
        if (deviceType === 'Echo' || deviceType === 'Echo 5G') {
          currentSelectedDeviceTypes.push('Echo');
        } else if (deviceType === 'Pivot 5G Service' || deviceType === 'Pivot 5G Donor' || deviceType === 'Pivot 5G') {
          currentSelectedDeviceTypes.push('Pivot 5G');
        } else {
          currentSelectedDeviceTypes.push(deviceType);
        }
      }
    });
  }

  !isObjectEmpty(softwareVersions) &&
    softwareVersions['all'].forEach((sw) => {
      let supportedDeviceTypes = sw.supported_device_types;
      let transferredSupportedDeviceTypes = [];
      if (supportedDeviceTypes && currentSelectedDeviceTypes.length > 0) {
        supportedDeviceTypes.forEach((type) => {
          if (defaultSWDeviceTypes[type]) {
            transferredSupportedDeviceTypes.push(defaultSWDeviceTypes[type].title);
          }
        });

        for (let i = 0; i < currentSelectedDeviceTypes.length; i++) {
          let curType = currentSelectedDeviceTypes[i];
          if (!transferredSupportedDeviceTypes.includes(curType)) {
            sw['muted'] = true;
            unavailableSwList.push(sw);
            break;
          }
          if (i === currentSelectedDeviceTypes.length - 1) {
            sw['muted'] = false;
            availableSwList.push(sw);
          }
        }
      } else {
        sw['muted'] = true;
        unavailableSwList.push(sw);
      }
    });

  let allSwList = [...availableSwList, ...unavailableSwList];

  useEffect(() => {
    if (availableSwList.length === 0) {
      parent.setState({ hasNoAvailableSwVersion: true });
    } else {
      parent.setState({ hasNoAvailableSwVersion: false });
    }
  });

  return (
    <div className="BulkSoftwareDownloadModal_ConfigPanel_swVersionList_Container">
      <PerfectScrollbar>
        {allSwList && allSwList.length > 0 ? (
          allSwList.map((sw, idx) => {
            let swVersion = sw.sw_version;
            let swIdentifier = sw.sw_identifier;
            let supportedDeviceTypes = sw.supported_device_types;
            let noMarginBottom = idx === allSwList.length - 1;
            let muted = sw.muted;
            let chips = supportedDeviceTypes ? (
              supportedDeviceTypes.map((deviceType, idx2) => {
                let deviceTypeObj = defaultSWDeviceTypes[deviceType];
                return deviceTypeObj ? (
                  <div
                    className={classnames({
                      BulkSoftwareDownloadModal_ConfigPanel_DeviceTypeChip: true,
                      BulkSoftwareDownloadModal_ConfigPanel_DeviceTypeChip_Muted: muted
                    })}
                    key={idx2}
                    data-tip={deviceTypeObj.title}
                  >
                    {deviceTypeObj.title}
                  </div>
                ) : (
                  <div key={idx2}></div>
                );
              })
            ) : (
              <div key={idx}></div>
            );

            return (
              <div
                className={classnames({
                  BulkSoftwareDownloadModal_ConfigPanel_swVersionList_Item: true,
                  BulkSoftwareDownloadModal_ConfigPanel_swVersionList_Item_Selected:
                    swIdentifier === selectedSWVersionID,
                  BulkSoftwareDownloadModal_ConfigPanel_swVersionList_Item_Muted: muted,
                  noMarginBottom
                })}
                key={idx}
                onClick={() => {
                  parent.setState({
                    selectedSWVersionID: swIdentifier,
                    targetSwVersionIndex: idx,
                    targetSwVersion: sw
                  });
                }}
              >
                <span className="BulkSoftwareDownloadModal_ConfigPanel_swVersionList_Item_Title" data-tip={swVersion}>
                  {swVersion}
                </span>
                <div
                  className={classnames({
                    BulkSoftwareDownloadModal_ConfigPanel_cellWrapper: true,
                    BulkSoftwareDownloadModal_ConfigPanel_DeviceTypeChipsWrapper: true
                  })}
                >
                  <PerfectScrollbar>{chips}</PerfectScrollbar>
                </div>
              </div>
            );
          })
        ) : (
          <div className="BulkSoftwareDownloadModal_ConfigPanel_NoSwVersionList">No software version is available.</div>
        )}
      </PerfectScrollbar>
    </div>
  );
};
